/**
 * PreSet AGM Exempted with Unaudited Financial Statements — 문서 준비 payload.
 */
import { classifyAgmExemptedUfsDoc } from './agmExemptedUfsDocVariableMap';
import {
  toAgmExemptedUfsDirectorsResolutionOnlyVariables,
  type AgmExemptedUfsFormModel,
} from './useFormPayload';
import { buildAgmExemptedUfsMembersResolutionSignerVariables } from './agmExemptedUfsSigners';
import { buildSgPresetPrepareDocumentItem } from '../../../presetDocCustSave';

export interface SelectionDocRow {
  tmpId?: number | null;
  templateName?: string;
}

const MEMBERS_MULTIPLE = /members?['_\s]*resolutions?.*multiple/i;
const MEMBERS_SOLE_CORPORATE = /members?['_\s]*resolutions?.*sole\s*corporate/i;
const MEMBERS_SOLE_INDIVIDUAL = /members?['_\s]*resolutions?.*sole\s*individual/i;

type MemberType = 'multiple' | 'sole_corporate' | 'sole_individual';

function shouldIncludeDoc(templateName: string, memberType: MemberType): boolean {
  if (MEMBERS_MULTIPLE.test(templateName)) return memberType === 'multiple';
  if (MEMBERS_SOLE_CORPORATE.test(templateName)) return memberType === 'sole_corporate';
  if (MEMBERS_SOLE_INDIVIDUAL.test(templateName)) return memberType === 'sole_individual';
  return true;
}

export function buildAgmExemptedUfsPresetPrepareDocuments(input: {
  selectionDocuments: SelectionDocRow[];
  commonFormData: Record<string, any>;
  formModel: AgmExemptedUfsFormModel;
  personName: string;
  entityCd?: string;
  memberType: MemberType;
}) {
  const drOnlyVars = toAgmExemptedUfsDirectorsResolutionOnlyVariables(input.formModel);

  return (input.selectionDocuments || [])
    .filter((d) => d.tmpId)
    .filter((d) => shouldIncludeDoc(d.templateName || '', input.memberType))
    .map((d) => {
      const templateName = d.templateName || '';
      const docKind = classifyAgmExemptedUfsDoc(templateName);
      let commonFormData = { ...input.commonFormData };

      if (docKind === 'directors_resolution') {
        commonFormData = {
          ...commonFormData,
          ...drOnlyVars,
        };
      } else if (
        docKind === 'members_resolution_multiple'
        || docKind === 'members_resolution_sole_corporate'
        || docKind === 'members_resolution_sole_individual'
      ) {
        const memberSigners = buildAgmExemptedUfsMembersResolutionSignerVariables(
          input.formModel,
          docKind,
        );
        if (memberSigners) {
          commonFormData = { ...commonFormData, ...memberSigners };
        }
      }

      return buildSgPresetPrepareDocumentItem({
        templateId: d.tmpId as number | string,
        templateName,
        personName: input.personName,
        commonFormData,
        entityCd: input.entityCd,
      });
    });
}
